import { useState } from 'react'
import { Input } from 'reactstrap'
import { isDisabled } from '../../utils'

export default function AppObjectFieldTime({ field, action, value, handleChange, hasChanged }) {
  console.log(`AppObjectFieldTime rendered: ${field.name}`)

  const [time, setTime] = useState(value)

  function handleTimeChange(event) {
    setTime(event.target.value)
    handleChange(event, hasChanged)
  }

  if (isDisabled(action, field.behaviorType)) {
    return (<span>{time}</span>)
  }
  return (
    <Input
      type="time"
      name={field.id}
      bsSize="sm"
      id={field.id}
      value={time}
      onChange={(event) => handleTimeChange(event, hasChanged)}
    />
  )
}
